export const experienceList = [
  {
    id: "1",
    role: "Full Stack Developer",
    company: "EU Start-Up",
    time: "March 2024 - Present",
    summary:
      "Built an AI-powered recruitment platform with a monorepo structure. Developed multiple modules for candidates, HR, and administration. Created a design system with reusable UI components using Storybook and Tailwind CSS. Integrated third-party APIs for authentication, file storage, and real-time notifications.",
  },
  {
    id: "2",
    role: "Full Stack React + SPFx Developer",
    company: "Nestlé Switzerland",
    time: "April 2023 - Feb 2024",
    summary:
      "Developed SharePoint solutions using SPFx and React.js. Automated workflows using SharePoint REST & Graph APIs. Contributed to CI/CD pipelines and backend automation with Node.js.",
  },
  {
    id: "3",
    role: "Oracle NetSuite ERP Developer",
    company: "Folio3 Software Inc.",
    time: "Feb 2023 - Jan 2024",
    summary:
      "Built custom scripts & integrations for Oracle NetSuite ERP. Developed APIs to sync Shopify & WooCommerce orders with NetSuite. Automated inventory updates and business workflows.",
  },
  {
    id: "4",
    role: "Full Stack Developer",
    company: "Salsoft Technologies",
    time: "July 2022 - Jan 2023",
    summary:
      "Built MERN stack applications. Developed RESTful APIs for seamless data exchange. Integrated third-party APIs and optimized backend performance.",
  },
  {
    id: "5",
    role: "Full Stack Developer",
    company: "SoftCube",
    time: "Nov 2021 - July 2022",
    summary:
      "Developed frontend applications with React.js & Next.js. Implemented SharePoint integrations using SPFx, REST APIs, and Graph APIs.",
  },
];